/**
 * SkipLink — invisible-until-focused link that lets keyboard / screen-reader
 * users jump past the persistent header straight to the main content.
 *
 * 10 of our pages have sticky headers (inspection list, vessel profile,
 * vetting layout, etc.). Without a skip link, every Tab keystroke from
 * the URL bar lands on a navigation control before reaching the page
 * body — exhausting on long pages and a WCAG 2.4.1 violation.
 *
 * Mount once at the very top of the React tree (App.tsx). Pages that
 * want to be jump-targets render `<main id="main-content">…</main>` and
 * the link will scroll/focus into them on activation.
 */
import React from 'react';

export default function SkipLink() {
  return (
    <a
      href="#main-content"
      className="
        sr-only focus:not-sr-only
        focus:fixed focus:left-4 focus:top-4 focus:z-[100]
        focus:px-3 focus:py-2 focus:rounded-lg
        focus:bg-cyan-500 focus:text-white focus:font-semibold focus:text-sm
        focus:shadow-xl focus:outline-none focus:ring-2 focus:ring-white/40
      "
    >
      Skip to main content
    </a>
  );
}
